var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"cart-empty"},[_c('h1',{domProps:{"innerHTML":_vm._s(_vm.$t('terminal.cart.cart.empty'))}}),_c('div',{staticClass:"description",domProps:{"innerHTML":_vm._s(_vm.description)}}),_c('div',{staticClass:"image"},[_c('img',{attrs:{"src":_vm.iconProductScan}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }